// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1C-DW","title":"header-module--title--3_b9J","nav":"header-module--nav--woLQT","link":"header-module--link--1EMsL"};